import permisosImportaciones, { RESOURCE_IMPORTACIONES } from '@/auth/permissions/modules/importacionesPg'
import {
    ROUTE_APROBACION_LIQUIDACION_IMP,
    ROUTE_ASIGNACION_GASTO_IMPORTACION,
    ROUTE_BANDEJA_APROBACION_REQUERIMIENTO_IMP,
    ROUTE_BANDEJA_GASTO_IMPORTACION,
    ROUTE_BANDEJA_PENDIENTE_NACIONALIZAR,
    ROUTE_CIERRE_IMPORTACION,
    ROUTE_CREAR_REQUERIMIENTO_IMP,
    ROUTE_DISTRIBUCION_IMPORTACION,
    ROUTE_GASTO_IMPORTACION,
    ROUTE_GESTION_DISTRIBUCION_IMPORTACION,
    ROUTE_GESTION_LIQUIDACION_IMP,
    ROUTE_GESTION_REQUERIMIENTOS_IMP,
    ROUTE_LIQUIDACION_IMPORTACION,
    ROUTE_NACIONALIZACION_IMPORTACION,
    ROUTE_RECEPCION_IMPORTACION,
} from '@/router/routes/importaciones-pg/nombres/transacciones'
import { defineMenu } from '@/utils/menu'

const { transacciones } = permisosImportaciones

export default defineMenu([
    {
        title: 'importaciones.subopciones.gestion_requerimientos',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.gestionRequerimiento,
        route: ROUTE_GESTION_REQUERIMIENTOS_IMP,
    },
    {
        title: 'importaciones.subopciones.crear_requerimiento',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.crearRequerimiento,
        route: ROUTE_CREAR_REQUERIMIENTO_IMP,
    },
    {
        title: 'importaciones.subopciones.aprobacion_requerimiento',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.bandejaAprobacion,
        route: ROUTE_BANDEJA_APROBACION_REQUERIMIENTO_IMP,
    },
    {
        title: 'importaciones.subopciones.bandeja_gasto_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.bandejaGastoImportacion,
        route: ROUTE_BANDEJA_GASTO_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.gasto_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.gastoImportacion,
        route: ROUTE_GASTO_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.bandeja_pendiente_nacionalizar',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.bandejaPendienteNacionalizar,
        route: ROUTE_BANDEJA_PENDIENTE_NACIONALIZAR,
    },
    {
        title: 'importaciones.subopciones.nacionalizacion_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.nacionalizacionImportacion,
        route: ROUTE_NACIONALIZACION_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.gestion_distribucion_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.bandejaDistribucionImportacion,
        route: ROUTE_GESTION_DISTRIBUCION_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.distribucion_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.distribucionImportacion,
        route: ROUTE_DISTRIBUCION_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.recepcion_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.recepcionImportacion,
        route: ROUTE_RECEPCION_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.bandeja_liquidacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.gestionLiquidacion,
        route: ROUTE_GESTION_LIQUIDACION_IMP,
    },
    {
        title: 'importaciones.subopciones.liquidacion_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.liquidacionImportacion,
        route: ROUTE_LIQUIDACION_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.aprobacion_liquidacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.aprobacionLiquidacion,
        route: ROUTE_APROBACION_LIQUIDACION_IMP,
    },
    {
        title: 'importaciones.subopciones.cierre_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.cierreImportacion,
        route: ROUTE_CIERRE_IMPORTACION,
    },
    {
        title: 'importaciones.subopciones.asignacion_gasto_importacion',
        resource: RESOURCE_IMPORTACIONES,
        action: transacciones.asignacionGastoImportacion,
        route: ROUTE_ASIGNACION_GASTO_IMPORTACION,
    },
])
